module.exports = __webpack_public_path__ + "img/old-site-selector-menu.b787aeaa.svg";